import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "liv-categories-products mb_30 mt_30" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Prise de commande ")
  ])
], -1)
const _hoisted_2 = {
  key: 0,
  class: "container mt_50 mb_50"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-xl-8 col-lg-8 col-md-7 col-sm-12 col-12" }
const _hoisted_5 = {
  key: 0,
  class: "row tf__menu_search_area search"
}
const _hoisted_6 = { class: "col-xl-20 col-lg-20 col-sm-20" }
const _hoisted_7 = { class: "float-end" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "deliveryIcon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "box1" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "icon-food_icon_delivery fs1"
    })
  ])
], -1)
const _hoisted_9 = { class: "titre first-letter-maj" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "deliveryIcon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "box1" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "icon-food_icon_shop fs1"
    })
  ])
], -1)
const _hoisted_11 = { class: "titre first-letter-maj" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "deliveryIcon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "box1" }, [
    /*#__PURE__*/_createElementVNode("i", {
      "aria-hidden": "true",
      class: "icon-food_icon_shop fs1"
    })
  ])
], -1)
const _hoisted_13 = { class: "titre first-letter-maj" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = { class: "category" }
const _hoisted_18 = { class: "liv_category_name" }
const _hoisted_19 = { class: "mb-3 first-letter-maj" }
const _hoisted_20 = {
  key: 1,
  class: "row products-by-category"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "productContent" }
const _hoisted_23 = { class: "productInfos" }
const _hoisted_24 = { class: "productImg image-zoom" }
const _hoisted_25 = ["src", "alt"]
const _hoisted_26 = { class: "productDesc" }
const _hoisted_27 = { class: "flex-md-column" }
const _hoisted_28 = { class: "first-letter-maj" }
const _hoisted_29 = {
  key: 0,
  class: "first-letter-maj"
}
const _hoisted_30 = {
  key: 1,
  class: "first-letter-maj"
}
const _hoisted_31 = { class: "producPrice mt_10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_promos_component = _resolveComponent("promos-component")!
  const _component_notfound_component = _resolveComponent("notfound-component")!
  const _component_cart_component = _resolveComponent("cart-component")!
  const _component_custom_modal_add_to_cart = _resolveComponent("custom-modal-add-to-cart")!
  const _component_dialog_confirmation = _resolveComponent("dialog-confirmation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.storeData?.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.cartStore?.deliveryMode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["", {
                        'col-md-4 col-lg-4 ': this.cartStore?.table?.id,
                        'col-lg-4 col-md-4 ': !this.cartStore?.table?.id,
                    }])
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          placeholder: "Rechercher",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.searchQuery) = $event)),
                          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.handleSearch && $options.handleSearch(...args)))
                        }, null, 544), [
                          [_vModelText, $data.searchQuery]
                        ])
                      ])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["deliveryMode", {
                        'fixedTop ': ($data.deliveryModeFixedTop && $options.checkUrl('/produits')),
                        'col-md-0 d-none ': this.cartStore?.table?.id,
                        'col-md-8 ': !this.cartStore?.table?.id,
                    }])
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["type", { active: _ctx.cartStore?.deliveryMode == 'at_place' }]),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.filterByDeliveryMode('at_place')))
                        }, [
                          _hoisted_8,
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('store.activity.atPlace')), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["type", { active: _ctx.cartStore?.deliveryMode == 'cac' }]),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.filterByDeliveryMode('cac')))
                        }, [
                          _hoisted_10,
                          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('store.activity.CandC')), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["type", { active: _ctx.cartStore?.deliveryMode == 'liv' }]),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.filterByDeliveryMode('liv')))
                        }, [
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('store.activity.delivery')), 1)
                        ], 2)
                      ])
                    ], 2)
                  ]))
                : _createCommentVNode("", true),
              ($data.filteredCategories.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.filteredCategories, (category, indexCat) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${indexCat}-${category}-categorie`,
                        class: "liv-categories-products mb_30 mt_30"
                      }, [
                        (category.products.length > 0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "row",
                              id: category.name
                            }, [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("h3", _hoisted_19, _toDisplayString(category.name), 1)
                                  ])
                                ])
                              ])
                            ], 8, _hoisted_15))
                          : _createCommentVNode("", true),
                        (category.products.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.products, (product, indexProd) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 mb_20 cursor-pointer",
                                  key: `${product.id}-${indexProd}-produit`,
                                  onClick: ($event: any) => ($options.PreparerYourProduct(product))
                                }, [
                                  _createElementVNode("div", _hoisted_22, [
                                    (product.promos.length > 0)
                                      ? (_openBlock(), _createBlock(_component_promos_component, {
                                          key: 0,
                                          promos: product.promos,
                                          className: "promo-product"
                                        }, null, 8, ["promos"]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_23, [
                                      _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("img", {
                                          class: "d-flex justify-content-start align-items-center",
                                          src: $options.getImageUrl(product.path_image),
                                          alt: product.name
                                        }, null, 8, _hoisted_25)
                                      ]),
                                      _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("div", _hoisted_27, [
                                          _createElementVNode("h3", _hoisted_28, _toDisplayString(product.name), 1),
                                          ($options.concatenateNamesOfIngredients(product))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString($options.concatenateNamesOfIngredients(product)), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(product?.description), 1))
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_31, [
                                      _createElementVNode("span", null, " €" + _toDisplayString($data.ProductUtils.productPrice(product).toFixed(2)), 1)
                                    ])
                                  ])
                                ], 8, _hoisted_21))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock(_component_notfound_component, {
                    key: 2,
                    title: "Aucun résultat",
                    description: "Désolé, le produit que vous cherchez est indisponible .",
                    img: ""
                  }))
            ]),
            _createVNode(_component_cart_component)
          ])
        ]))
      : _createCommentVNode("", true),
    ($data.isModalAddToCartOpen)
      ? (_openBlock(), _createBlock(_component_custom_modal_add_to_cart, {
          key: 1,
          modelValue: $data.isModalAddToCartOpen,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.isModalAddToCartOpen) = $event)),
          product: _ctx.productsStore.currentProduct,
          action: 'add',
          indexProduct: 0,
          onToggleAddToCart: $options.handleToggleAddToCart,
          isModalAddToCartOpen: $data.isModalAddToCartOpen
        }, null, 8, ["modelValue", "product", "onToggleAddToCart", "isModalAddToCartOpen"]))
      : _createCommentVNode("", true),
    _createVNode(_component_dialog_confirmation, { ref: "dialogConfirmation" }, null, 512)
  ], 64))
}